export const SITE_URL = "https://www.homecraft-masters.com";
export const SITE_NAME = "HomeCraft Masters";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`;

export const DEFAULT_SEO = {
  title: "Custom Kitchen Cabinets in Colorado | HomeCraft Masters",
  description:
    "HomeCraft Masters designs and builds custom kitchens and cabinetry in Colorado. Explore our completed projects and schedule a consultation.",
  path: "/",
};

export const PAGE_SEO = {
  home: DEFAULT_SEO,
  about: {
    title: "About Our Custom Cabinetry Company | HomeCraft Masters",
    description:
      "Meet HomeCraft Masters, a family-owned Colorado company creating custom kitchens with European-inspired design, quality materials, and careful craftsmanship.",
    path: "/about",
  },
  gallery: {
    title: "Custom Kitchen & Cabinetry Projects | HomeCraft Masters",
    description:
      "Explore custom kitchen and cabinetry projects completed by HomeCraft Masters across Colorado, including Denver, Aurora, Evergreen, Genesee, and Winter Park.",
    path: "/gallery",
  },
  reviews: {
    title: "Customer Reviews | HomeCraft Masters",
    description:
      "Read what HomeCraft Masters customers say about our custom kitchen design, cabinetry, craftsmanship, and service in Colorado.",
    path: "/reviews",
  },
  contacts: {
    title: "Contact HomeCraft Masters | Custom Kitchens in Colorado",
    description:
      "Contact HomeCraft Masters to discuss your custom kitchen or cabinetry project in Colorado. Call +1 720-380-6636 or send us a message.",
    path: "/contacts",
  },
  notFound: {
    title: "Page Not Found | HomeCraft Masters",
    description: "The requested HomeCraft Masters page could not be found.",
    path: "/404",
    noIndex: true,
  },
};

export const LOCAL_BUSINESS_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "HomeAndConstructionBusiness",
  "@id": `${SITE_URL}/#business`,
  name: SITE_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/web-logo.svg`,
  image: DEFAULT_OG_IMAGE,
  description: DEFAULT_SEO.description,
  telephone: "+1-720-380-6636",
  email: "contact@homecraft-masters.com",
  areaServed: {
    "@type": "State",
    name: "Colorado",
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "https://schema.org/Monday",
        "https://schema.org/Tuesday",
        "https://schema.org/Wednesday",
        "https://schema.org/Thursday",
        "https://schema.org/Friday",
      ],
      opens: "08:00",
      closes: "17:00",
    },
  ],
  sameAs: ["https://www.instagram.com/homecraft_masters/"],
};

export const WEBSITE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  url: SITE_URL,
  name: SITE_NAME,
  publisher: {
    "@id": `${SITE_URL}/#business`,
  },
  inLanguage: "en-US",
};
